import { FunctionComponent } from "react";

import {
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  TooltipHost
} from "@bps/fluent-ui";
import { BaseUserStatuses } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface TenantUserStatusBadgeProps {
  isInactive?: boolean;
  status?: BaseUserStatuses;
  isPremierTenant: boolean;
}

const OPS_CONSOLE_LABEL = "Ops Console";
const PREM_SITE_LABEL = "Prem Site";

export const TenantUserStatusBadge: FunctionComponent<TenantUserStatusBadgeProps> = ({
  isInactive,
  status,
  isPremierTenant
}) => {
  const isOpsActive = !isInactive;

  // Prem/PROS site status only applies to Premier tenants (DEX-provisioned) -
  // for CAM tenants it's meaningless, so don't let it drag the badge to yellow.
  if (!isPremierTenant) {
    return (
      <TextBadge
        badgeSize={TextBadgeSize.small}
        badgeColor={isOpsActive ? TextBadgeColor.green : TextBadgeColor.red}
        styles={{ root: { width: 90 } }}
      >
        {isOpsActive ? "Active" : "Inactive"}
      </TextBadge>
    );
  }

  const isPremActive = status === BaseUserStatuses.active;

  const badgeColor = (() => {
    if (isOpsActive && isPremActive) return TextBadgeColor.green;
    if (!isOpsActive && !isPremActive) return TextBadgeColor.red;
    return TextBadgeColor.yellow;
  })();

  const badgeText = (() => {
    if (isOpsActive && isPremActive) return "Active (2)";
    if (!isOpsActive && !isPremActive) return "Inactive (2)";
    return `Active (${
      isOpsActive ? OPS_CONSOLE_LABEL[0] : PREM_SITE_LABEL[0]
    })`;
  })();

  return (
    <TooltipHost
      content={
        <Stack tokens={{ childrenGap: 4 }}>
          <Text variant="small">
            {OPS_CONSOLE_LABEL}: {isOpsActive ? "Active" : "Inactive"}
          </Text>
          <Text variant="small">
            {PREM_SITE_LABEL}: {isPremActive ? "Active" : "Inactive"}
          </Text>
        </Stack>
      }
      styles={{ root: { display: "inline-flex" } }}
    >
      <TextBadge
        badgeSize={TextBadgeSize.small}
        badgeColor={badgeColor}
        styles={{ root: { width: 90 } }}
      >
        {badgeText}
      </TextBadge>
    </TooltipHost>
  );
};
